export default __webpack_public_path__ + "static/komodo-b81dff95fb94fc4553922ef10904bcc5.png";